import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=39f9daca&scoped=true"
import script from "./DeviceType.vue?vue&type=script&lang=js"
export * from "./DeviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9daca",
  null
  
)

export default component.exports